import React from 'react';
import { withFirebase } from '../Firebase';
import { NappButton } from './button';

const SignOutButton = ({ firebase }) => (
  <a href="/" onClick={(ev) => { ev.preventDefault(); firebase.signOut(); }}> Logg ut</a >
);

export default withFirebase(SignOutButton);